export const style = {
  nonEditable: {
    cursor: `default`
  },
  title: {
    fontSize: `12px`,
    fontWeight: `600`
  },
  content: {
    color: `#666`,
    fontWeight: 400
  },
  edit: {
    fontSize: `12px`,
    color: `#A94545`
  },
  editSpan: {
    marginLeft: `5px`
  },
  nonEditableEdit: {
    color: `#a0a0a0`,
    textDecoration: `none`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/User/partials/UserEditor/partials/AccountDetails/style/tableRow.js